import { render, staticRenderFns } from "./ItsRegistOverheadsDetail.vue?vue&type=template&id=1093c6b1&scoped=true&"
import script from "./ItsRegistOverheadsDetail.vue?vue&type=script&lang=js&"
export * from "./ItsRegistOverheadsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsRegistOverheadsDetail.vue?vue&type=style&index=0&id=1093c6b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093c6b1",
  null
  
)

export default component.exports